export const MAX_OPTION_NAME_LENGTH = 50

export const Resources = {
  singleSelectOptionLimitWarning: (count: number) => `Maximum of ${count} options reached`,
}

export const VALIDATION_MESSAGES = {
  REQUIRED: 'Label text is required',
  TOO_LONG: `Label text must be ${MAX_OPTION_NAME_LENGTH} characters or fewer`,
  DUPLICATE: 'Option has already been taken',
} as const
